module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2fqGg"))).then(() => parcelRequire('4kPjv'));